import React, {useState, useEffect} from 'react';
import SelectField from '../../libs/react-components-admin/fields/select-field';
import ColorField from '../../libs/react-components-admin/fields/color-field';

const widths = [
  {label: '100%', value: '100'},
  {label: '83.33%', value: '83.33'},
  {label: '66.66%', value: '66.66'},
  {label: '50%', value: '50'},
  {label: '33.33%', value: '33.33'},
  {label: '16.66%', value: '16.66'},
];

const FormStyle = ({panelEnabled, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  const [_panelEnabled, setPanelEnabled] = useState(!!panelEnabled);

  useEffect(() => { onChange(model); }, [model]);
  useEffect(() => {
    setPanelEnabled(!!panelEnabled);
    if (!panelEnabled && model.bgColor) {
      setModel({...model, bgColor: null});
    }
  }, [panelEnabled]);

  return <div className="row">
    <div className="col-12 col-md-6">
      <SelectField id="styleWidth"
                   label="Width"
                   helpBlock={<>Note: ignored in the preview, or when displayed in a pop-up</>}
                   values={widths}
                   value={model.widthInPercent}
                   onChange={v => setModel({...model, widthInPercent: v})}/>
    </div>
    <div className="col-12 col-md-6">
      <div className="mb-3">
        <label htmlFor="styleFontFamily" className="form-label">Font family</label>
        <input id="styleFontFamily" name="styleFontFamily"
               type="text"
               className="form-control"
               value={model.fontFamily || ''}
               onChange={e => setModel({...model, fontFamily: e.target.value})}/>
      </div>
    </div>
    <div className="col-12 col-md-6">
      <ColorField id="styleFontColor"
                  label="Font color"
                  value={model.fontColor}
                  onChange={v => setModel({...model, fontColor: v})}/>
    </div>
    {_panelEnabled &&
      <div className="col-12 col-md-6">
        <ColorField id="styleBgColor"
                    label="Background color"
                    valueOnChoose="#FFFFFF"
                    value={model.bgColor}
                    onChange={v => setModel({...model, bgColor: v})}/>
      </div>
    }
    <div className="col-12">
      <div className="mb-3">
        <label htmlFor="styleCustomCss" className="form-label">Custom CSS</label>
        <textarea id="styleCustomCss" name="styleCustomCss"
                  className="form-control"
                  style={{minHeight: '8em'}}
                  placeholder=".acerill-custom-form { color: red; }"
                  value={model.customCss || ''}
                  onChange={e => setModel({...model, customCss: e.target.value})}/>
      </div>
    </div>
  </div>;
};

export default FormStyle;
